import api from "./api";



const inquireProfileInfo=async( id) =>{
	
	const apiPath = `/profileinfo/inquireprofileinfo/${id}`;
	console.log("profileinfo " + apiPath);
	const response = api.get(apiPath);
	return response;
}

const inquireExhibit=async( id) =>{
	
	const apiPath = `/exhibition/${id}`;
	console.log("inquireExhibit " + apiPath);
	const response = api.get(apiPath);
	return response;

}

const inquireExhibitByStatus=async( status) =>{
	
	const apiPath = `/exhibition/inquireexhibitbystatus/${status}`;
	console.log("inquireexhibitbystatus " + status);
	const response = api.get(apiPath);
	return response;

	
}

const inquireExhibitByUserAndStatus=async(userId, status) =>{
	
	const apiPath = `/exhibition/inquireexhibitbyuserstatus/${userId}/${status}`;
	console.log("inquireExhibitByUserAndStatus " + status);
	const response = api.get(apiPath);
	return response;

	
}


const inquireFollower=async( id) =>{
	
	const apiPath = `/profileinfo/inquirefollower/${id}`;
	console.log("inquirefollower " + apiPath);
	const response = api.get(apiPath);
	return response;
}

const inquireFollowed=async( id) =>{
	
	const apiPath = `/profileinfo/inquirefollowed/${id}`;
	console.log("inquirefollowed " + apiPath);
	const response = api.get(apiPath);
	return response;
}


const save=(apiParams) =>{
	
	const apiPath = `/exhibition/save`;  
	apiParams={ ...apiParams, tenantId: 1 };


	console.log("save exhibition " + apiPath);
	let url=apiPath;

	
	let data=apiParams;

	const response = api.post(url ,data);
	return response;
}
const update=(apiParams) =>{
	
	const apiPath = `/exhibition/update`;  
	apiParams={ ...apiParams, tenantId: 1 };


	console.log("update exhibition " + apiPath);
	let url=apiPath;

	
	let data=apiParams;

	const response = api.post(url ,data);
	return response;
}


const changeStatus=(apiParams) =>{
	
	const apiPath = `/exhibition/changestatus`;  
	apiParams={ ...apiParams, tenantId: 1 };


	console.log("update exhibition " + apiPath);
	let url=apiPath;

	
	let data=apiParams;

	const response = api.post(url ,data);
	return response;
}

const addFollow=(profileID) =>{
	
	const apiPath = `/profileinfo/addfollow?profileID=${profileID}`;  
	

	let url=apiPath;

	

	const response = api.post(url);
	return response;
}



const removeFollow=(profileID) =>{
	
	const apiPath = `/profileinfo/removefollow?profileID=${profileID}`;  
	

	let url=apiPath;

	

	const response = api.post(url);
	return response;
}


const inquireFeaturedExhibitsByFilterType=async( filterType) =>{
	
	const apiPath = `/exhibition/inquirefeaturedexhibits/${filterType}`;
	console.log("inquirefeaturedexhibits " + filterType);
	const response = api.get(apiPath);
	return response;

	
}


const inquireFeaturedExhibits=async( ) =>{
	
	const apiPath = `/exhibition/inquirefeaturedexhibits`;
	console.log("inquirefeaturedexhibits " );
	const response = api.get(apiPath);
	return response;

	
}

const inquireNewExhibits=async( ) =>{
	
	const apiPath = `/exhibition/inquirenewexhibits`;
	console.log("inquirenewexhibits " );
	const response = api.get(apiPath);
	return response;

	
}

const inquireFavoriteExhibits=async( ) =>{
	
	const apiPath = `/exhibition/inquirefavoriteexhibits`;
	console.log("inquirefavoriteexhibits " );
	const response = api.get(apiPath);
	return response;

	
}


const inquireExhibitOverviewReport=async( ) =>{
	
	const apiPath = `/exhibition/inquireexhibitoverviewreport`;
	console.log("inquireExhibitOverviewReport " );
	const response = api.get(apiPath);
	return response;

	
}



const ExhibitionService = {
	inquireProfileInfo,
	inquireExhibit,
	inquireExhibitByStatus,
	inquireExhibitByUserAndStatus,
	save,
	update,
	changeStatus,
	addFollow,
	removeFollow,
	inquireFollower,
	inquireFollowed,
	inquireFeaturedExhibitsByFilterType,
	inquireFeaturedExhibits,
	inquireNewExhibits,
	inquireFavoriteExhibits,
	inquireExhibitOverviewReport
	
};

export default ExhibitionService;
